import { AppProvider as SharedAppProvider } from '@cfra-nextgen-frontend/shared/src/providers/AppProvider';
import { configureAmplify } from 'config/auth';
import { AppRoutes } from '../routes/AppRoutes';

configureAmplify();

export function AppProvider() {
    return <SharedAppProvider appRoutesJsx={<AppRoutes />} />;
}
